<template>
  <div>
    <vl-map
      :load-tiles-while-animating="true"
      :load-tiles-while-interacting="true"
      data-projection="EPSG:4326"
      style="height: 650px"
      @click="setPos"
    >
      <vl-view
        :zoom.sync="zoom"
        :center.sync="center"
        :rotation.sync="rotation"
        :min-zoom="3"
        :extent="[60, 90, -85, 0]"
      ></vl-view>
      <vl-geoloc @update:position="geolocPosition = $event"> </vl-geoloc>
      <vl-feature id="my-locatoin" v-if="!!geolocPosition">
        <vl-geom-point :coordinates="geolocPosition"></vl-geom-point>
        <vl-style-box>
          <vl-style-icon
            src="@/assets/map-marker-icon.png"
            :scale="0.04"
            :anchor="[0.5, 1]"
          ></vl-style-icon>
        </vl-style-box>
      </vl-feature>
      <vl-layer-tile id="osm">
        <vl-source-osm></vl-source-osm>
      </vl-layer-tile>
    </vl-map>
  </div>
</template>

<script>
import mapTypes from "@/store/types/map";
export default {
  data() {
    return {
      zoom: 3,
      center: [0, 0],
      rotation: 0,
      geolocPosition: undefined,
    };
  },
  methods: {
    setPos(newPos) {
      this.geolocPosition = newPos.coordinate;
      this.updateVuex(this.geolocPosition);
    },
    updateVuex(geolocPosition) {
      this.$store.commit(mapTypes.mutations.setLongitude, geolocPosition[0]);
      this.$store.commit(mapTypes.mutations.setLatitude, geolocPosition[1]);
      this.center = [geolocPosition[0], geolocPosition[1]];
      this.zoom = 17;
    },
  },
  watch: {
    geolocPosition() {
      if (!!this.geolocPosition) {
        this.updateVuex(this.geolocPosition);
      }
    },
  },
};
</script>